import PenPal from "./Programs/PenPal";
import Forms from "./Programs/Forms";

export default function Programs() {
  return (
    <div>
      <PenPal />
      <Forms />
    </div>
  );
}
